<template>
  <div
    class="markdown-body"
    v-html="this.documentData.content"
    style="margin-top: 2%"
  ></div>
</template>

<script>
import 'github-markdown-css/github-markdown.css';

export default {
  name: 'markdown',
  props: {
    documentData: {
      default: () => {},
    },
  },
};
</script>

<style scoped></style>
